import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "title !mb-0" }
const _hoisted_2 = { class: "text-neutral-50 text-lg text-center" }

import { useSalePhase } from "@/composables/useSalePhase";
import AppCta from "@/components/app/AppCta.vue";
import ImageCenteredSection from "@/components/section/ImageCenteredSection.vue";


export default /*#__PURE__*/_defineComponent({
  __name: 'CtaSection',
  props: ["id"],
  setup(__props) {


const { isPreSale } = useSalePhase();

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(ImageCenteredSection, {
    id: __props.id,
    src: require('@/assets/images/seminar-hall.png'),
    alt: _unref(isPreSale) ? 'Mint your NFT now' : 'Mint your NFT now',
    gradient: true
  }, {
    default: _withCtx(() => [
      _createElementVNode("div", null, [
        _createElementVNode("h2", _hoisted_1, _toDisplayString(_unref(isPreSale) ? "Mint your NFT now" : "Mint your NFT now"), 1)
      ]),
      _createElementVNode("div", null, [
        _createElementVNode("p", _hoisted_2, _toDisplayString(_unref(isPreSale)
                        ? "Buy your unique DRIPVERSITY NFT from the collection drop on Foundation."
                        : "Buy your unique DRIPVERSITY NFT from the collection drop on Foundation."), 1)
      ]),
      _createElementVNode("div", null, [
        _createVNode(AppCta, { color: "secondary" })
      ])
    ]),
    _: 1
  }, 8, ["id", "src", "alt"]))
}
}

})